var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvisibileRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    "data-name": "Livello 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 869.24 929.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e10a17;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 0,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 42.05,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 81.61,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 118.81,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 153.81,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 186.73,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 217.7,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 246.83,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 274.22,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 300,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 324.24,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 347.04,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 368.5,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 388.68,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 407.67,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 425.54,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 442.36,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 458.19,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 473.09,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 487.13,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 500.35,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 512.81,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 524.56,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 535.64,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 546.1,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 555.97,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 565.31,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 574.14,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 582.5,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 590.42,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 597.94,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 605.08,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 611.88,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 618.36,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 624.53,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 630.44,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 636.09,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 641.5,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 646.71,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 651.72,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 656.56,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 661.23,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 665.77,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 670.17,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 674.46,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 678.64,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 682.73,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 686.75,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 690.69,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 694.58,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 698.42,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 702.21,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 705.98,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 709.72,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 713.44,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 717.15,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 720.85,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 724.55,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 728.26,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 731.98,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 735.71,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 739.46,
    width: 868.98,
    height: 3.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 743.23,
    width: 868.98,
    height: 3.05
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.26,805v-5.78h71.78v5.78H.26ZM.26,812.27v-5.78h71.78v5.78H.26ZM.26,922.46v-5.78h71.78v5.78H.26ZM.26,929.73v-5.78h71.78v5.78H.26ZM29.53,819.73v-5.78h13.24v5.78h-13.24ZM29.53,827v-5.78h13.24v5.78h-13.24ZM29.53,834.27v-5.78h13.24v5.78h-13.24ZM29.53,841.73v-5.78h13.24v5.78h-13.24ZM29.53,849v-5.78h13.24v5.78h-13.24ZM29.53,856.27v-5.78h13.24v5.78h-13.24ZM29.53,863.73v-5.78h13.24v5.78h-13.24ZM29.53,871v-5.78h13.24v5.78h-13.24ZM29.53,878.46v-5.78h13.24v5.78h-13.24ZM29.53,885.73v-5.78h13.24v5.78h-13.24ZM29.53,893v-5.78h13.24v5.78h-13.24ZM29.53,900.46v-5.78h13.24v5.78h-13.24ZM29.53,907.73v-5.78h13.24v5.78h-13.24ZM29.53,915v-5.78h13.24v5.78h-13.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.82,805v-5.78h13.05v5.78h-13.05ZM88.82,812.27v-5.78h13.05v5.78h-13.05ZM88.82,819.73v-5.78h27.78v5.78h-27.78ZM88.82,827v-5.78h27.78v5.78h-27.78ZM88.82,834.27v-5.78h13.05v5.78h-13.05ZM88.82,841.73v-5.78h13.05v5.78h-13.05ZM88.82,849v-5.78h13.05v5.78h-13.05ZM88.82,856.27v-5.78h13.05v5.78h-13.05ZM88.82,863.73v-5.78h13.05v5.78h-13.05ZM88.82,871v-5.78h13.05v5.78h-13.05ZM88.82,878.46v-5.78h13.05v5.78h-13.05ZM88.82,885.73v-5.78h13.05v5.78h-13.05ZM88.82,893v-5.78h13.05v5.78h-13.05ZM88.82,900.46v-5.78h13.05v5.78h-13.05ZM88.82,907.73v-5.78h13.05v5.78h-13.05ZM88.82,915v-5.78h13.05v5.78h-13.05ZM88.82,922.46v-5.78h13.05v5.78h-13.05ZM88.82,929.73v-5.78h13.05v5.78h-13.05ZM118.09,834.27v-5.78h13.05v5.78h-13.05ZM118.09,841.73v-5.78h13.05v5.78h-13.05ZM132.82,849v-5.78h27.78v5.78h-27.78ZM132.82,856.27v-5.78h27.78v5.78h-27.78ZM147.55,805v-5.78h13.05v5.78h-13.05ZM147.55,812.27v-5.78h13.05v5.78h-13.05ZM147.55,819.73v-5.78h13.05v5.78h-13.05ZM147.55,827v-5.78h13.05v5.78h-13.05ZM147.55,834.27v-5.78h13.05v5.78h-13.05ZM147.55,841.73v-5.78h13.05v5.78h-13.05ZM147.55,863.73v-5.78h13.05v5.78h-13.05ZM147.55,871v-5.78h13.05v5.78h-13.05ZM147.55,878.46v-5.78h13.05v5.78h-13.05ZM147.55,885.73v-5.78h13.05v5.78h-13.05ZM147.55,893v-5.78h13.05v5.78h-13.05ZM147.55,900.46v-5.78h13.05v5.78h-13.05ZM147.55,907.73v-5.78h13.05v5.78h-13.05ZM147.55,915v-5.78h13.05v5.78h-13.05ZM147.55,922.46v-5.78h13.05v5.78h-13.05ZM147.55,929.73v-5.78h13.05v5.78h-13.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.38,805v-5.78h13.05v5.78h-13.05ZM177.38,812.27v-5.78h13.05v5.78h-13.05ZM177.38,819.73v-5.78h13.05v5.78h-13.05ZM177.38,827v-5.78h13.05v5.78h-13.05ZM177.38,834.27v-5.78h13.05v5.78h-13.05ZM177.38,841.73v-5.78h13.05v5.78h-13.05ZM177.38,849v-5.78h13.05v5.78h-13.05ZM177.38,856.27v-5.78h13.05v5.78h-13.05ZM177.38,863.73v-5.78h13.05v5.78h-13.05ZM177.38,871v-5.78h13.05v5.78h-13.05ZM177.38,878.46v-5.78h13.05v5.78h-13.05ZM177.38,885.73v-5.78h13.05v5.78h-13.05ZM177.38,893v-5.78h13.05v5.78h-13.05ZM177.38,900.46v-5.78h13.05v5.78h-13.05ZM192.11,907.73v-5.78h13.05v5.78h-13.05ZM192.11,915v-5.78h13.05v5.78h-13.05ZM206.65,922.46v-5.78h13.24v5.78h-13.24ZM206.65,929.73v-5.78h13.24v5.78h-13.24ZM221.38,907.73v-5.78h13.05v5.78h-13.05ZM221.38,915v-5.78h13.05v5.78h-13.05ZM236.11,805v-5.78h13.05v5.78h-13.05ZM236.11,812.27v-5.78h13.05v5.78h-13.05ZM236.11,819.73v-5.78h13.05v5.78h-13.05ZM236.11,827v-5.78h13.05v5.78h-13.05ZM236.11,834.27v-5.78h13.05v5.78h-13.05ZM236.11,841.73v-5.78h13.05v5.78h-13.05ZM236.11,849v-5.78h13.05v5.78h-13.05ZM236.11,856.27v-5.78h13.05v5.78h-13.05ZM236.11,863.73v-5.78h13.05v5.78h-13.05ZM236.11,871v-5.78h13.05v5.78h-13.05ZM236.11,878.46v-5.78h13.05v5.78h-13.05ZM236.11,885.73v-5.78h13.05v5.78h-13.05ZM236.11,893v-5.78h13.05v5.78h-13.05ZM236.11,900.46v-5.78h13.05v5.78h-13.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.93,805v-5.78h71.78v5.78h-71.78ZM265.93,812.27v-5.78h71.78v5.78h-71.78ZM265.93,922.46v-5.78h71.78v5.78h-71.78ZM265.93,929.73v-5.78h71.78v5.78h-71.78ZM295.2,819.73v-5.78h13.24v5.78h-13.24ZM295.2,827v-5.78h13.24v5.78h-13.24ZM295.2,834.27v-5.78h13.24v5.78h-13.24ZM295.2,841.73v-5.78h13.24v5.78h-13.24ZM295.2,849v-5.78h13.24v5.78h-13.24ZM295.2,856.27v-5.78h13.24v5.78h-13.24ZM295.2,863.73v-5.78h13.24v5.78h-13.24ZM295.2,871v-5.78h13.24v5.78h-13.24ZM295.2,878.46v-5.78h13.24v5.78h-13.24ZM295.2,885.73v-5.78h13.24v5.78h-13.24ZM295.2,893v-5.78h13.24v5.78h-13.24ZM295.2,900.46v-5.78h13.24v5.78h-13.24ZM295.2,907.73v-5.78h13.24v5.78h-13.24ZM295.2,915v-5.78h13.24v5.78h-13.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.49,819.73v-5.78h13.05v5.78h-13.05ZM354.49,827v-5.78h13.05v5.78h-13.05ZM354.49,834.27v-5.78h13.05v5.78h-13.05ZM354.49,841.73v-5.78h13.05v5.78h-13.05ZM354.49,907.73v-5.78h13.05v5.78h-13.05ZM354.49,915v-5.78h13.05v5.78h-13.05ZM369.03,805v-5.78h42.51v5.78h-42.51ZM369.03,812.27v-5.78h42.51v5.78h-42.51ZM369.03,849v-5.78h13.24v5.78h-13.24ZM369.03,856.27v-5.78h13.24v5.78h-13.24ZM369.03,922.46v-5.78h42.51v5.78h-42.51ZM369.03,929.73v-5.78h42.51v5.78h-42.51ZM383.76,863.73v-5.78h13.24v5.78h-13.24ZM383.76,871v-5.78h13.24v5.78h-13.24ZM398.49,878.46v-5.78h13.05v5.78h-13.05ZM398.49,885.73v-5.78h13.05v5.78h-13.05ZM413.22,819.73v-5.78h13.05v5.78h-13.05ZM413.22,827v-5.78h13.05v5.78h-13.05ZM413.22,893v-5.78h13.05v5.78h-13.05ZM413.22,900.46v-5.78h13.05v5.78h-13.05ZM413.22,907.73v-5.78h13.05v5.78h-13.05ZM413.22,915v-5.78h13.05v5.78h-13.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M443.05,805v-5.78h71.78v5.78h-71.78ZM443.05,812.27v-5.78h71.78v5.78h-71.78ZM443.05,922.46v-5.78h71.78v5.78h-71.78ZM443.05,929.73v-5.78h71.78v5.78h-71.78ZM472.32,819.73v-5.78h13.24v5.78h-13.24ZM472.32,827v-5.78h13.24v5.78h-13.24ZM472.32,834.27v-5.78h13.24v5.78h-13.24ZM472.32,841.73v-5.78h13.24v5.78h-13.24ZM472.32,849v-5.78h13.24v5.78h-13.24ZM472.32,856.27v-5.78h13.24v5.78h-13.24ZM472.32,863.73v-5.78h13.24v5.78h-13.24ZM472.32,871v-5.78h13.24v5.78h-13.24ZM472.32,878.46v-5.78h13.24v5.78h-13.24ZM472.32,885.73v-5.78h13.24v5.78h-13.24ZM472.32,893v-5.78h13.24v5.78h-13.24ZM472.32,900.46v-5.78h13.24v5.78h-13.24ZM472.32,907.73v-5.78h13.24v5.78h-13.24ZM472.32,915v-5.78h13.24v5.78h-13.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M531.6,799.22h57.05v5.78h-57.05v-5.78ZM531.6,806.49h57.05v5.78h-57.05v-5.78ZM544.66,813.95v5.78h-13.05v-5.78h13.05ZM544.66,821.22v5.78h-13.05v-5.78h13.05ZM544.66,828.49v5.78h-13.05v-5.78h13.05ZM544.66,835.95v5.78h-13.05v-5.78h13.05ZM544.66,843.22v5.78h-13.05v-5.78h13.05ZM544.66,850.49v5.78h-13.05v-5.78h13.05ZM531.6,857.95h57.05v5.78h-57.05v-5.78ZM531.6,865.22h57.05v5.78h-57.05v-5.78ZM544.66,872.68v5.78h-13.05v-5.78h13.05ZM544.66,879.95v5.78h-13.05v-5.78h13.05ZM544.66,887.22v5.78h-13.05v-5.78h13.05ZM544.66,894.68v5.78h-13.05v-5.78h13.05ZM544.66,901.95v5.78h-13.05v-5.78h13.05ZM544.66,909.22v5.78h-13.05v-5.78h13.05ZM531.6,916.68h57.05v5.78h-57.05v-5.78ZM531.6,923.95h57.05v5.78h-57.05v-5.78ZM590.33,813.95h13.05v5.78h-13.05v-5.78ZM590.33,827v-5.78h13.05v5.78h-13.05ZM590.33,834.27v-5.78h13.05v5.78h-13.05ZM590.33,841.73v-5.78h13.05v5.78h-13.05ZM590.33,849v-5.78h13.05v5.78h-13.05ZM590.33,856.27v-5.78h13.05v5.78h-13.05ZM590.33,878.46v-5.78h13.05v5.78h-13.05ZM590.33,885.73v-5.78h13.05v5.78h-13.05ZM590.33,893v-5.78h13.05v5.78h-13.05ZM590.33,900.46v-5.78h13.05v5.78h-13.05ZM590.33,907.73v-5.78h13.05v5.78h-13.05ZM590.33,915v-5.78h13.05v5.78h-13.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M620.16,805v-5.78h71.78v5.78h-71.78ZM620.16,812.27v-5.78h71.78v5.78h-71.78ZM620.16,922.46v-5.78h71.78v5.78h-71.78ZM620.16,929.73v-5.78h71.78v5.78h-71.78ZM649.43,819.73v-5.78h13.24v5.78h-13.24ZM649.43,827v-5.78h13.24v5.78h-13.24ZM649.43,834.27v-5.78h13.24v5.78h-13.24ZM649.43,841.73v-5.78h13.24v5.78h-13.24ZM649.43,849v-5.78h13.24v5.78h-13.24ZM649.43,856.27v-5.78h13.24v5.78h-13.24ZM649.43,863.73v-5.78h13.24v5.78h-13.24ZM649.43,871v-5.78h13.24v5.78h-13.24ZM649.43,878.46v-5.78h13.24v5.78h-13.24ZM649.43,885.73v-5.78h13.24v5.78h-13.24ZM649.43,893v-5.78h13.24v5.78h-13.24ZM649.43,900.46v-5.78h13.24v5.78h-13.24ZM649.43,907.73v-5.78h13.24v5.78h-13.24ZM649.43,915v-5.78h13.24v5.78h-13.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M708.72,805v-5.78h13.05v5.78h-13.05ZM708.72,812.27v-5.78h13.05v5.78h-13.05ZM708.72,819.73v-5.78h13.05v5.78h-13.05ZM708.72,827v-5.78h13.05v5.78h-13.05ZM708.72,834.27v-5.78h13.05v5.78h-13.05ZM708.72,841.73v-5.78h13.05v5.78h-13.05ZM708.72,849v-5.78h13.05v5.78h-13.05ZM708.72,856.27v-5.78h13.05v5.78h-13.05ZM708.72,863.73v-5.78h13.05v5.78h-13.05ZM708.72,871v-5.78h13.05v5.78h-13.05ZM708.72,878.46v-5.78h13.05v5.78h-13.05ZM708.72,885.73v-5.78h13.05v5.78h-13.05ZM708.72,893v-5.78h13.05v5.78h-13.05ZM708.72,900.46v-5.78h13.05v5.78h-13.05ZM708.72,907.73v-5.78h13.05v5.78h-13.05ZM708.72,915v-5.78h13.05v5.78h-13.05ZM708.72,922.46v-5.78h71.78v5.78h-71.78ZM708.72,929.73v-5.78h71.78v5.78h-71.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M797.27,805v-5.78h71.97v5.78h-71.97ZM797.27,812.27v-5.78h71.97v5.78h-71.97ZM797.27,819.73v-5.78h13.24v5.78h-13.24ZM797.27,827v-5.78h13.24v5.78h-13.24ZM797.27,834.27v-5.78h13.24v5.78h-13.24ZM797.27,841.73v-5.78h13.24v5.78h-13.24ZM797.27,849v-5.78h13.24v5.78h-13.24ZM797.27,856.27v-5.78h13.24v5.78h-13.24ZM797.27,863.73v-5.78h60.22v5.78h-60.22ZM797.27,871v-5.78h60.22v5.78h-60.22ZM797.27,878.46v-5.78h13.24v5.78h-13.24ZM797.27,885.73v-5.78h13.24v5.78h-13.24ZM797.27,893v-5.78h13.24v5.78h-13.24ZM797.27,900.46v-5.78h13.24v5.78h-13.24ZM797.27,907.73v-5.78h13.24v5.78h-13.24ZM797.27,915v-5.78h13.24v5.78h-13.24ZM797.27,922.46v-5.78h71.97v5.78h-71.97ZM797.27,929.73v-5.78h71.97v5.78h-71.97Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisibileRed);
export default __webpack_public_path__ + "static/media/Invisibile_red.2d860b3b949eff776199f843543adf50.svg";
export { ForwardRef as ReactComponent };